import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const CancelForwardModal = ({ open, handleClose, cancelForward }) => {
  const { t } = useTranslation();
  return (
    <div>
      <Dialog
        disableEnforceFocus
        open={open}
        aria-labelledby="draggable-dialog-title"
        onClose={handleClose}
        PaperProps={{ sx: { padding: "15px 10px", width: "100%" } }}
      >
        <DialogTitle id="draggable-dialog-title">
          <Typography variant="title4">{t("cancel_forward")}</Typography>
        </DialogTitle>{" "}
        <DialogContent>
          <DialogContentText>{t("confirm_cancel_forward")}</DialogContentText>
        </DialogContent>
        <DialogActions align="end">
          <Button onClick={handleClose}>{t("cancel")}</Button>
          <Button variant="contained" color="error" onClick={cancelForward}>
            {t("confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CancelForwardModal;
